import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import Swal from "sweetalert2";
import { FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { ExcelServiceService } from "src/app/excel-service.service";
import * as XLSX from "xlsx";
import { CommonService } from "src/app/services/common.service";
import { ErrorModalComponent } from "../../error-modal/error-modal.component";
import { StorageService } from "../../../services/storage.service";
import CryptoJS from "crypto-js";

@Component({
  selector: "app-nonapproval-report",
  templateUrl: "./nonapproval-report.component.html",
  styleUrls: ["./nonapproval-report.component.css"],
})
export class NonapprovalReportComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  fileName = "ExcelSheet.xlsx";
  page: number = 1;
  page_size: number = 10;
  videoList: any;
  video: any;
  prolength: any;
  department: any;
  dept: any;
  classroom: any;
  class: any;
  subject: any;
  subjectData: any;
  department_id: any;
  subject_id: any;
  classroom_id: any;
  professor: any;
  filter_from: any;
  filter_end: any;
  timeid: any;
  timetable_id: number;
  videost: Object;
  vid: any;
  video_message: any;
  pageshow = true;
  total_count: any;
  page_count: any;
  htmlpageshow = false;
  batch: any;
  batchData: any;
  batch_id: any;
  total: any;
  p: number;
  pagedItems: any[];
  video1: any;
  videodownload: any;
  startdate: any;
  first_name: any;
  last_name: any;
  sno: number;
  uivideoList: any;
  excelVideoList: any;
  sdate: any;
  professorData: any;
  professor_id: any;
  professorname: Object;
  searchForm: any;
  viderror: Object;
  errstatus: any;
  error_status_id: any;
  error_message: any;
  maxDate: any;
  value: string;
  check: number;
  dropbox: Array<Object> = [];
  pageno: any;
  recrange: any;
  filtervalues: boolean;
  chiparray = [];
  isAudiable: string = "";
  audio_availability: any = "";
  isNonNumeric: boolean = true;
  numericError: boolean = false;
  isActive: any = "";
  role: any;
  ishod: any;
  sessionData: any;
  minDate: Date;
  findedVal: any;
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    private excelservice: ExcelServiceService,
    private fb: FormBuilder,
    public router: Router,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private datepipe: DatePipe,
    private route: ActivatedRoute,
    public commonService: CommonService
  ) {
    this.role = this.storageService.getRole();
    this.ishod = this.storageService.getHod();
  }
  roleId = this.storageService.getRole();
  async ngOnInit() {
    this.maxDate = new Date();
    this.minDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate() - 1);
    this.searchForm = this.fb.group({
      id: [""],
      date: [null],
      statmessage: [null],
      error_message: [null],
      proname: [null],
      depname: [null],
      batchname: [null],
      classname: [null],
      subjectname: [null],
      isAudiable: [null],
      audio_availability: [null],
      session: [null],
    });
    if (this.storageService.getRole() == 4 && this.ishod !== 1) {
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].setValue(this.professor_id);
      this.searchForm.controls["proname"].disable();
    }
    this.getDepartment();
    this.getSubject();
    this.getclassroom();
    this.getVideostatus();
    this.getErrorstatus();
    this.getBatch();
    this.getProfessor();
  }
  async getPage(page: number) {
    this.page = page;
    await this.getvideoList();
    const res = await this.serverCall(this.video, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }

  get forms1() {
    return this.searchForm.controls;
  }

  getvalue(event: any, rec: any) {
    this.spinner.show();
    this.recrange = rec;
    this.pageno = event;
    this.exportAsXLSX();
  }

  async dropboxdown() {
    this.dropbox = [];
    var count = 1000,
      tempcount = 1000,
      c1,
      c2;
    this.check = Math.ceil(this.total_count / count);
    var cvar = 1;
    for (let i = 1; i <= this.check; i++) {
      c1 = cvar;
      c2 = count;
      cvar = cvar + tempcount;
      count += tempcount;
      this.dropbox.push({ value: i, records: c1 + "-" + c2 });
    }
  }

  async getvideoList() {
    this.spinner.show();
    this.timeid = this.route.params.subscribe((params) => {
      this.timetable_id = +params["id"];
    });

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      page: this.page,
      page_size: this.page_size,
      video_status_id: this.video_message,
      error_status_id: this.error_message,
      department_id: this.department_id ? this.department_id : this.searchForm.controls["depname"].value,
      subject_id: this.subject_id,
      batch_id: this.batch_id,
      professor_id: this.professor_id ? this.professor_id : this.searchForm.controls["proname"].value,
      classroom_id: this.classroom_id,
      has_audio: this.isAudiable,
      audio_availability: this.audio_availability,
      is_active: this.isActive,
      start_date: this.filter_from || moment(new Date()).format("YYYY-MM-DD"),
      end_date: this.filter_end || moment(new Date()).format("YYYY-MM-DD"),
      session_id: this.findedVal?.id,
    };
    const dateKeyExists = this.chiparray.some((chip) => chip.startsWith("Date :"));

    if (!dateKeyExists) {
      this.chiparray.push("Date :" + " " + filter.start_date + " - " + filter.end_date);
    }
    await this.globalService
      .get("classVideoDetail/get-non-approved-videodetails", filter)
      .then((data) => {
        this.videoList = data;

        this.total_count = this.videoList["content"].count;
        this.video1 = this.videoList["content"];
        this.video = this.videoList["content"]["rows"];

        if (this.pageshow === true) {
          this.page_count = [];
          let page_count = Math.ceil(this.total_count / this.page_size);
          if (page_count > 1) {
            this.htmlpageshow = true;
          } else {
            this.htmlpageshow = false;
          }
          this.spinner.hide();
        }
      });
    this.spinner.hide();
    this.prolength = this.video?.length;
    this.dropboxdown();
  }
  async videoenc(id, hlsStatus) {
    const encrypt = (text) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    };
    const enryptText = hlsStatus == "0" ? "ZERO" : "ONE";
    window.open(`/video/play?key=${id}&isHls=${encrypt(enryptText)}&loginType=${this.storageService.getImpersonateTextForUrl()}`, "_blank");
  }
  async getVideostatus() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.videost = await this.globalService.get(
      "classVideoDetail/list/dropdown/schedule/flow/status",
      filter
    );

    this.vid = this.videost["content"];
    this.spinner.hide();
  }
  async getErrorstatus() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.viderror = await this.globalService.get(
      "classVideoDetail/list/dropdown/error-schedule-status",
      filter
    );

    this.errstatus = this.viderror["content"];
    this.spinner.hide();
  }
  async getProfessor() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.professorname = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.professorData = this.professorname["content"];

    // GET SESSION
    let session = await this.globalService.get(
      "session/dropdown",
      filter,
      true
    );

    this.sessionData = session["content"];
    this.forms1["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.findedVal = this.sessionData.find(
      (list) => list.session === this.searchForm.controls['session']?.value
    );
    this.onSessionChangeEvent(true);
    this.Filter();
    this.spinner.hide();
  }

  async onSessionChangeEvent(isInitLoad?) {
    this.forms1["date"].setValue(null);
    this.getFilterDate(null);
    let sessionVal = this.forms1["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData.find(
        (list) => list.session === sessionVal
      );
      await this.getSubjectDropdown();
      this.minDate.setDate(new Date(this.findedVal.start_date).getDate());
      this.minDate.setMonth(new Date(this.findedVal.start_date).getMonth());
      this.minDate.setFullYear(
        new Date(this.findedVal.start_date).getFullYear()
      );
      // this.maxDate.setDate(new Date(this.findedVal.end_date).getDate());
      // this.maxDate.setMonth(new Date(this.findedVal.end_date).getMonth());
      // this.maxDate.setFullYear(new Date(this.findedVal.end_date).getFullYear());
      if (isInitLoad) {
        let splitedChipArray = null;
        if (this.chiparray.length) {
          this.chiparray.forEach((elem) => {
            if (elem.split(" : ")[0] === "Date") {
              splitedChipArray = elem.split(" : ")[1].split(" - ");
            }
          })
        }
        if (splitedChipArray?.length) {
          const convertedDates = splitedChipArray.map(dateStr => new Date(dateStr));
          this.forms1["date"].setValue(convertedDates);
          this.getFilterDate(convertedDates);
        } else {
          this.forms1["date"].setValue([new Date(), new Date()]);
          this.getFilterDate([new Date(), new Date()]);
        }
      }
    } else {
      this.forms1["date"].setValue(null);
      this.getFilterDate(null);
    }
  }

  async onDepartmentChange() {
    await this.getSubjectDropdown();
    await this.getProfessorDropdown();
  }

  async getProfessorDropdown() {
    this.spinner.show();

    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    const departmentId = this.searchForm.get("depname")?.value;

    if (departmentId) {
      filter.department_id = departmentId;
    }

    const professor = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.professorData = professor["content"] || [];

    // Clear selected professor after department changes
    this.searchForm.patchValue({
      proname: null,
    });
    this.professor_id = null;

    this.spinner.hide();
  }

  async getSubjectDropdown() {
    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    if (this.findedVal?.id) {
      filter.session_id = this.findedVal.id;
    }

    const departmentId = this.searchForm.get("depname")?.value;
    if (departmentId) {
      filter.department_id = departmentId;
    }

    const subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = subject["content"] || [];

    // Clear previously selected subject if needed
    this.searchForm.patchValue({
      subjectname: null,
    });
  }

  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );

    this.dept = this.department["content"];
    if (this.storageService.getRole() == 4 && this.ishod == 1) {
      this.department_id = this.storageService.getDepartment();
    }
    this.spinner.hide();
  }
  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(dateValue, timeValue, isDateRequested);
  }
  getFilterDate(filter_date) {
    if (filter_date) {
      let from = moment(filter_date[0]).format("YYYY-MM-DD");
      let end = moment(filter_date[1]).format("YYYY-MM-DD");
      this.filter_from = this.datepipe.transform(from, "yyyy-MM-dd");
      this.filter_end = this.datepipe.transform(end, "yyyy-MM-dd");
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
          new Date(this.filter_end).getTime()
        ) / oneDay; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
          new Date(this.filter_end).getTime()
        ) / oneDay;
      if (-diffDays > 180) {
        Swal.fire({
          text: "Please select dates within 180 days",

          icon: "warning",

          confirmButtonText: "OK",

          confirmButtonColor: "#808080",
        });
        this.searchForm.controls["date"].setValue("");
      }
    } else {
      this.filter_from = "";
      this.filter_end = "";
    }
  }
  async getclassroom() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.classroom = await this.globalService.get(
      "classroom/list/dropdown",
      filter,
      true
    );

    this.class = this.classroom["content"];
    this.spinner.hide();
  }
  async getSubject() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = this.subject["content"];
    this.spinner.hide();
  }
  async getBatch() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.batch = await this.globalService.get(
      "batch/list/dropdown",
      filter,
      true
    );

    this.batchData = this.batch["content"];
    this.spinner.hide();
  }
  openScrollableContent(longContent) {
    this.findedVal = null;
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
    // this.searchForm.reset();
    if (!this.forms1["session"].value) {
      this.forms1["session"].setValue(
        this.storageService.getCurrentSession(this.sessionData)?.session
      );
    }
    this.onSessionChangeEvent(true);
    if (this.storageService.getRole() === 4 && this.ishod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
    }
    if (this.storageService.getRole() === 4 && this.ishod !== 1) {
      this.searchForm.controls["proname"].setValue(
        this.storageService.getProfessor()
      );
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].disable();
    }
  }
  Filter() {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.searchForm.controls["session"]?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.controls["session"]?.value
      );
    }
    // if(this.filter_from && this.filter_end) {
    //   this.chiparray.push(
    //     "Date :" + " " + this.filter_from + " - " + this.filter_end
    //   );
    // }    

    if (this.video_message != undefined && this.video_message != "") {
      var vidmsg = this.vid.filter((x) => x.id == this.video_message);
      this.chiparray.push("Vidmsg:" + " " + vidmsg[0].status_message);
    }
    if (this.error_message != undefined && this.error_message != "") {
      var errmsg = this.errstatus.filter((x) => x.id == this.error_message);
      this.chiparray.push("Errmsg :" + " " + errmsg[0].status_message);
    }
    if (this.professor_id != undefined && this.professor_id != "") {
      var proffessor = this.professorData.filter(
        (x) => x.id == this.professor_id
      );
      this.chiparray.push(
        "Proff:" +
        " " +
        proffessor[0].first_name +
        " " +
        proffessor[0].last_name
      );
    }

    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }

    if (this.subject_id != undefined && this.subject_id != "") {
      var subject = this.subjectData.filter((x) => x.id == this.subject_id);
      this.chiparray.push("Subject:" + " " + subject[0].name);
    }

    if (this.batch_id != undefined && this.batch_id != "") {
      var batch = this.batchData.filter((x) => x.id == this.batch_id);
      this.chiparray.push("Batch:" + " " + batch[0].batch);
    }

    if (this.classroom_id != undefined && this.classroom_id != "") {
      var classroom = this.class.filter((x) => x.id == this.classroom_id);
      this.chiparray.push("Class:" + " " + classroom[0].name);
    }
    if (this.searchForm.controls['audio_availability']?.value) {
      this.chiparray.push(
        "Audio Availability : " + this.searchForm.controls['audio_availability']?.value
      );
    }
    if (this.department_id !== "" || this.subject_id !== "" || this.batch_id != "") {
      this.department_id = this.department_id ? this.department_id : this.searchForm.controls["depname"]?.value;
      this.subject_id = this.searchForm.controls['subjectname']?.value;
      this.audio_availability = this.searchForm.controls['audio_availability']?.value;
      this.classroom_id = this.searchForm.controls['classname']?.value;
      this.video_message = this.searchForm.controls['statmessage']?.value;
      this.error_message = this.searchForm.controls['error_message']?.value;
      this.batch_id = this.searchForm.controls['batchname']?.value;
    } else {
      this.department_id = "";
      this.subject_id = "";
      this.classroom_id = "";
      this.video_message = "";
      this.error_message = "";
      this.batch_id = "";
    }

    this.pageshow = true;
    // this.professor_id = this.searchForm.controls['professorname']?.value;;
    this.page = 1;

    this.getvideoList();
  }
  getUtcTimeToLocale(dateValue, timeValue, isDateRequested) {
    var UTCDate = moment
      .utc(dateValue + " " + timeValue)
      .toDate()
      .toLocaleTimeString("en-US");
    return UTCDate;
  }
  async exportAsXLSX() {
    this.spinner.show();
    var count = 1000;
    var startUTCDate = moment(this.filter_from, "YYYY-MM-DD");
    var endUTCDate = moment(this.filter_end, "YYYY-MM-DD");
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      page: this.total_count > 1000 ? this.pageno : 1,
      page_size: 1000,
      video_status_id: this.video_message,
      error_status_id: this.error_message,
      department_id: this.department_id,
      subject_id: this.subject_id,
      batch_id: this.batch_id,
      classroom_id: this.classroom_id,
      start_date: this.filter_from || moment(new Date()).format("YYYY-MM-DD"),
      end_date: this.filter_end || moment(new Date()).format("YYYY-MM-DD"),
      session_id: this.findedVal?.id,
    };

    this.videodownload = await this.globalService.get(
      "classVideoDetail/get-non-approved-videodetails",
      filter
    );

    this.excelVideoList = this.videodownload["content"]["rows"];
    var startTM;
    var endTM;
    this.excelVideoList.forEach((e, i) => {
      startTM = this.getUtcTimeToLocale(
        this.excelVideoList[i].start_date,
        this.excelVideoList[i].start_time,
        ""
      );
      this.excelVideoList[i]["start_time"] = startTM;
      endTM = this.getUtcTimeToLocale(
        this.excelVideoList[i].end_date,
        this.excelVideoList[i].end_time,
        ""
      );
      this.excelVideoList[i]["end_time"] = endTM;
    });
    this.uivideoList = this.excelVideoList.map((item: any) => {
      return {
        DEPARTMENT_NAME: item.department_details.name,
        CLASSROOM: item.classroom_details.name,
        SUBJECT: item.subject_details.batch,
        PROFESSOR_NAME: item.professor_details
          ? item.professor_details.first_name + item.professor_details.last_name
          : "",
        BATCH_DEATILS: item.batch_details.batch,
        STATUS_MESSAGE: item.VideoStatus ? item.VideoStatus.status_message : "",
        ERROR_MESSAGE: item.VideoStatusError
          ? item.VideoStatusError.status_message
          : "",
        STARTDATE: item.start_date,
        END_DATE: item.end_date,
        CAMERA_START: item.camera_start,
        CAMERA_END: item.camera_end,
        START_TIME: item.start_time,
        END_TIME: item.end_time,
        AUDIO_AVAILABILITY: item.audio_availability,
      };
    });

    this.excelservice.exportAsExcelFile(
      this.uivideoList,
      "Non Approval Report" + " " + [this.recrange]
    );

    this.spinner.hide();
  }
  res() {
    this.chiparray = [];
    this.forms1["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.findedVal = this.sessionData?.find(
      (list) => list.session === this.searchForm.controls["session"]?.value
    ) || null;
    this.chiparray.push(
      "Session : " + this.searchForm.controls["session"]?.value
    );
    if (this.storageService.getRole() == 4 && this.ishod == 1) {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
      this.professor_id = null;
    }
    if (this.storageService.getRole() == 4 && this.ishod != 1) {
      var proff = this.professorData.filter((x) => x.id == this.professor_id);
      this.chiparray.push("Proff:" + " " + proff[0].first_name + " " + proff[0].last_name);
      this.department_id = null;
    }
    this.filtervalues = false;
    if (this.storageService.getRole() != 4) {
      this.department_id = null;
      this.professor_id = null;
    }
    this.subject_id = null;
    this.classroom_id = null;
    this.filter_from = null;
    this.filter_end = null;
    this.video_message = null;
    this.error_message = null;
    this.batch_id = null;
    this.audio_availability = null;
    this.isAudiable = null;
    // this.searchForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getvideoList();
  }
  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getvideoList();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getvideoList();
  }

  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getvideoList();
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getvideoList();
  }
  statusFilter(value) {
    if (value) {
      this.isActive = 1;
    } else {
      this.isActive = "";
    }
    this.getvideoList();
  }
  checkNumeric(value) {
    this.audio_availability = this.searchForm.controls.audio_availability.value;
    if (this.audio_availability == null) {
      this.audio_availability = "";
    }
    if (value % 1 != 0) {
      this.isNonNumeric = true;
      this.audio_availability = "";
      this.numericError = true;
    } else {
      this.isNonNumeric = false;
      this.numericError = false;
    }
  }
}
